import { useCallback, useContext, useState } from "react";
import { CONTENT_BASE_URL } from "../../../shared/constants";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { IImageProps } from "./Image.interface";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { ComponentTypes } from "../../../shared/interfaces/modules.interface";
import { useIntersectionObserver } from "../../../shared/hooks/useIntersectionObserver";

function Image({ image, unitId, id, type }: IImageProps) {
    const { url, alt = "", width, height } = image;
    const { progress, setProgress } = useContext(ModuleContext);
    const { lang } = useContext(TranslationContext);

    const [isCompleted, setIsCompleted] = useState<boolean>(false);

    const checkProgress = useCallback(
        (entry: any) => {
            const isItemId = id === progress?.itemId && type === progress?.itemType;

            if (entry.isIntersecting && !isItemId && !isCompleted) {
                handleProgress();
            }
        },
        [progress, isCompleted]
    );

    const handleProgress = useCallback(() => {
        if (lang && unitId) {
            setProgress({
                unitId: unitId,
                itemId: id,
                progress: 100,
                itemType: ComponentTypes.IMAGE,
                itemLocale: lang
            });
            setIsCompleted(true);
        }
    }, [lang, unitId]);

    const { ref } = useIntersectionObserver(checkProgress);

    return (
        <section className="unit_item container-fluid gx-2">
            <div className="row gx-0">
                <div className="col-12">
                    <img
                        className="w-100 h-auto"
                        ref={ref}
                        src={`${CONTENT_BASE_URL}${url}`}
                        alt={alt}
                        width={width}
                        height={height}
                    />
                </div>
            </div>
        </section>
    );
}

export default Image;
